
import {map} from 'rxjs/operators';
/**
 * Created by sagil on 22/08/2016.
 */
import {Injectable} from "@angular/core";
import {LookupsService} from "../../lookups/services/lookups.service";
import {LookupResponse} from "../../lookups/response.lookup";
import {Observable} from "rxjs";
import {FlagWeb} from "../../lookups/lookups.types/interfaces/flag.web";
import {TranslateService} from "../../../common/translate/services/translate.service";
import {FLAG_SUFFIX} from "../../../common/translate/translate.suffix";
import {IWorklistFlag} from "../../worklists/interfaces/Iworklist.flag";
import {LogManager} from "../../../common/log/services/log.manager";
import {LogCat} from "../../../common/log/services/log.manager.categories";
import {SvgIconsService} from "../../../common/ui/components/svg.icons/services/svg.icons.service";
import {FlagsProxy} from "./flags.proxy";

/**
 * ***************************************************************
 * The Flags service is responsible for providing access
 * to the flags information which is lookup data.
 *
 * Written by: Sagi Levi
 * ***************************************************************
 */
@Injectable({ providedIn: 'root' })
  export class FlagsService {

	public readonly BLANKS_FLAG_WEB_KEY = -1;
	public readonly NON_BLANKS_FLAG_WEB_KEY = -2;

	constructor(private lookupsService: LookupsService,
				private translateService: TranslateService,
				private svgIconsService: SvgIconsService,
				private flagsProxy: FlagsProxy) {
	}

	public flagDisplayName(flag:FlagWeb.FlagWeb | IWorklistFlag){
		return <string>(this.translateService.instant(flag.name + FLAG_SUFFIX));
	}
	public getFlags() : Observable<FlagWeb.FlagWeb[]> {
		let request = this.lookupsService.createRequestGetAllRecords(FlagWeb.lookupName, null, null);
		request.includeClobAndBlob = true;

		return this.lookupsService.getLookup(request).pipe(map((res:LookupResponse<any>) => {
			return res.lookupTable.data;
		}));
	}

	public getFlagsActionCode() :  Observable<{ [code: number]: string }> {
		return this.flagsProxy.getFlagsActionCode();
	}

	// public merge(firstFlagset : string, secondFlagset : string) : string {
	// 	let result = '';
	//
	// 	for (let i = 0; i < 64; ++i) {
	// 		let currBit = '0';
	//
	// 		if (firstFlagset && firstFlagset.length > i && firstFlagset[i] === '1') {
	// 			currBit = '1';
	// 		} else if (secondFlagset && secondFlagset.length > i && secondFlagset[i] === '1') {
	// 			currBit = '1';
	// 		}
	//
	// 		result += currBit;
	// 	}
	//
	// 	return result;
	// }

	// public turnBit(flagset : string, position: number) : string {
	// 	position = flagset.length - position - 1;
	//
	// 	if (flagset[position] === '1') {
	// 		return flagset;
	// 	}
	//
	// 	return flagset.substr(0, position) + '1' + flagset.substr(position+1);
	// }

	public calculateDisplayFlags(flagsBitArr:string,flagsMapData: FlagWeb.FlagWeb[], type:FlagWeb.IndicationType,flagsKeys:number[],
									maxFlagsToDisplay:number) :FlagWeb.FlagWeb[]{
		if (!flagsMapData) {
			LogManager.warn(LogCat.Flags.General, "flags calc with no flags metadata");
			return [];
		}

		let displayFlags = [];

		if (flagsBitArr) {
			//Create object that are keys they the keys of the flags.
			let flagsByKey: {[flagWebKey: number]: FlagWeb.FlagWeb} = {};

			flagsMapData.map((flag: FlagWeb.FlagWeb) => {
				let showFlag = true;

				if (type === FlagWeb.IndicationType.patient && flag.indicationType === FlagWeb.IndicationType.worklist) {
					showFlag = false;
				}

				if (type === FlagWeb.IndicationType.worklist && flag.indicationType === FlagWeb.IndicationType.patient) {
					showFlag = false;
				}

				if (showFlag) {
					let currFlag = Object.assign({}, flag);
					//currFlag.name = <string>(this.translateService.instant(currFlag.name + FLAG_SUFFIX));
					currFlag.name = this.flagDisplayName(currFlag);
					flagsByKey[flag.flagWebKey] = currFlag;
				}
			});

			// JavaScript bitwise is 32bit - JS bitwise operations are limited to 32bit numbers.
			// this is the real limitation for why we cannot support more than 32 flags with the current
			// implementation. can we just replace the & bitwise operation below with an &&
			//let max32 = 4294967296; // 2^32

			//The min/max safe numbers of JavaScript is 52 bits.

			// first flag is indicated on location 0 from the right and so on
			//let flagsBitArrStr=flagsBitArr?flagsBitArr.toString(2):"";
			let flagsBitArrStr=flagsBitArr;
			for (let i = 1; i < 129; i++) {
				if (flagsByKey[i] && (flagsBitArrStr.length>=i&& flagsBitArrStr[flagsBitArrStr.length-i]==='1')) {
					displayFlags.push(flagsByKey[i]);
				}
			}
		} else if (flagsKeys) {
			flagsKeys.forEach((flagKey)=>{
				let currFlag = Object.assign({}, flagsMapData.find((flagM) => flagM.flagWebKey === flagKey));
				currFlag.name = currFlag.name = this.flagDisplayName(currFlag);
				displayFlags.push(currFlag);
			});
		}

		// Sort by priority (ascending).
		displayFlags.sort((f1, f2) => (f1.priority > f2.priority) ? 1 : -1);

		//Limit the number of flags to display in the component.
		if (maxFlagsToDisplay) {
			displayFlags.splice(maxFlagsToDisplay);
		}
		return displayFlags;
	}

	public isRelevantFlag(level, patient, visit, order, requestedProcedure, sps, pps) {
		switch (level) {
			case 1:
				return (patient !== null);
			case 2:
				return (order !== null);
			case 3:
				return (requestedProcedure !== null);
			case 4:
				return (sps !== null);
			case 5:
				return (pps !== null);
		}

		return true; // level null means we're OK for all
	}

	public getSvgIconClassByKey(key: number): string {
		let svgIcon = this.svgIconsService.allSvgIcons.find(icon => icon.key === key);
		if (svgIcon && svgIcon.active) {
			return svgIcon.system ? svgIcon.name : svgIcon.key.toString();
		}
		return '';
	}
}
